<template>
    <path d="M24.917 23.083H32V32h-8.917v-5.419L16 19.072l-7.083 7.51V32H0v-8.917h7.083L14.25 16v-5.675c-1.053-.37-1.913-1.002-2.582-1.898-.668-.896-1.002-1.927-1.002-3.094 0-.938.241-1.82.725-2.645s1.138-1.48 1.963-1.963C14.18.242 15.06 0 16 0c.939 0 1.82.242 2.645.725.825.484 1.48 1.138 1.963 1.963.484.825.725 1.707.725 2.645 0 1.167-.334 2.198-1.002 3.094-.669.896-1.53 1.529-2.582 1.898V16l7.168 7.083z"/>
</template>

<script>
export default {
    name: 'uaHubIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 32 32');
    }
}
</script>
